export default __webpack_public_path__ + "static/media/copy.d8decb9c.svg";